import Vue from 'vue'
import Router from 'vue-router'
import mall from './mall'
import orders from './orders'
import roadwork from './roadwork'
import franchisee from './franchisee'
import finance from './finance'
import setting from './setting'
import system from './system'
import ad from './ad'
//-------三期--------
import budget from './budget'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      meta: {
        title: '首页'
      },
      component: () => import('@/views/home/index.vue')
    },
    {
      path: '/complainSuggest',
      meta: {
        title: '投诉建议'
      },
      component: () => import('@/views/ComplainSuggest.vue')
    },
    {
      path: '/error/404',
      component: () => import('@/views/error/404.vue')
    },
    {
      path: '/login',
      meta: {
        layout: 'blank'
      },
      component: () => import('@/views/Login.vue')
    },
    {
      path: '/logs',
      meta: {
        title: '系统日志'
      },
      component: () => import('@/views/Logs.vue')
    },
    {
      path: '/my-setting',
      meta: {
        title: '个人设置'
      },
      component: () => import('@/views/MySetting')
    },
    ...mall,
    ...orders,
    ...roadwork,
    ...franchisee,
    ...finance,
    ...setting,
    ...system,
    ...ad,
    ...budget,

    {
      path: '/supplier/user',
      meta: {
        title: '供货商用户'
      },
      component: () => import('@/views/supplier/User.vue')
    },
    {
      path: '/supplier/im',
      meta: {
        title: '客服会话'
      },
      component: () => import('@/views/supplier/IM.vue')
    },
    {
      path: '/supplier/pay',
      meta: {
        title: '支付信息'
      },
      component: () => import('@/views/supplier/pay-signing/index.vue')
    },
    {
      path: '/supplier/aftersale',
      meta: {
        title: '售后订单'
      },
      component: () => import('@/views/supplier/aftersale.vue')
    },

    {
      path: '/fundsrecord',
      meta: {
        title: '对账记录'
      },
      component: () => import('@/views/funds/record')
    },


    {
      path: '/settlement-review',
      meta: {
        title: '结算审核'
      },
      component: () => import('@/views/supplier/settlement-review')
    },
    {
      path: '/settlement-period',
      meta: {
        title: '结算账期'
      },
      component: () => import('@/views/supplier/settlement-period')
    },

    {
      path: '/enter_warehouse/list',
      name: 'enter_warehouse-list',
      meta: {
        title: '入库单列表'
      },
      component: () => import('@/views/enter_warehouse/list')
    },
    {
      path: '/enter_warehouse/detail/:orderNumber',
      name: 'enter_warehouse-detail',
      meta: {
        title: '入库商品明细'
      },
      component: () => import('@/views/enter_warehouse/detail')
    },

    {
      path: '/sample-photos-configure',
      meta: {
        title: '示例照片管理'
      },
      component: () => import('@/views/admin/SamplePhotos.vue')
    },
    {
      path: '/brand/qr-code',
      meta: {
        title: '品牌二维码'
      },
      component: () => import('@/views/admin/BrandQRCode.vue')
    },

  ]
})
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else if (to.path === '/noticeDetail') {
    next()
  } else {
    if (localStorage.getItem('token')) {
      // 到如果匹配到路由结果
      if (to.matched.length > 0) {
        next()
      } else {
        next('/error/404')
      }
    } else {
      next('/login')
    }
  }
})
export default router
